import React from "react";
import './dictionary-list.scss';
import { getImageSource } from "../../utility/image-source";
import { ImageConstants } from "../../constants/constants";
import CwContentViewer from "../common/cw-content-viewer/cw-content-viewer";
import DictionaryApi from "../../apis/dictionary";
import PaginationComponent from "../common/cw-pagination/cw-pagination-v2";
import ReactTooltip from 'react-tooltip';
import KeywordDetail from "./keyword-detail/keyword-detail";

class Dictionary extends React.Component {



    currentPage = 1
    limit = 10
    filter = {}

    alphabetHash = {}

    state = {
        comprehensionKeywordList: [
            // {
            //     "title": "TIMES",
            //     "meaning": "<p><em>Times</em>&nbsp;represents the mathematical operation of multiplication of numbers&nbsp;and is just another name for the operation. For example, the product of 3 and 7 is also termed as &ldquo;3 times 7&rdquo;.</p><p>&nbsp;</p><p>We know that repeated addition is adding equal groups together. It provides a foundation for understanding multiplication. For example, 3 times 5 can be understood as&nbsp;3 groups of 5 counters&nbsp;and then written as 5 + 5 + 5 = 15.</p>"
            // },
            // {
            //     "title": "TIMES",
            //     "meaning": "<p><em>Times</em>&nbsp;represents the mathematical operation of multiplication of numbers&nbsp;and is just another name for the operation. For example, the product of 3 and 7 is also termed as &ldquo;3 times 7&rdquo;.</p><p>&nbsp;</p><p>We know that repeated addition is adding equal groups together. It provides a foundation for understanding multiplication. For example, 3 times 5 can be understood as&nbsp;3 groups of 5 counters&nbsp;and then written as 5 + 5 + 5 = 15.</p>"
            // },
            // {
            //     "title": "TIMES",
            //     "meaning": "<p><em>Times</em>&nbsp;represents the mathematical operation of multiplication of numbers&nbsp;and is just another name for the operation. For example, the product of 3 and 7 is also termed as &ldquo;3 times 7&rdquo;.</p><p>&nbsp;</p><p>We know that repeated addition is adding equal groups together. It provides a foundation for understanding multiplication. For example, 3 times 5 can be understood as&nbsp;3 groups of 5 counters&nbsp;and then written as 5 + 5 + 5 = 15.</p>"
            // },
            // {
            //     "title": "TIMES",
            //     "meaning": "<p><em>Times</em>&nbsp;represents the mathematical operation of multiplication of numbers&nbsp;and is just another name for the operation. For example, the product of 3 and 7 is also termed as &ldquo;3 times 7&rdquo;.</p><p>&nbsp;</p><p>We know that repeated addition is adding equal groups together. It provides a foundation for understanding multiplication. For example, 3 times 5 can be understood as&nbsp;3 groups of 5 counters&nbsp;and then written as 5 + 5 + 5 = 15.</p>"
            // }
        ],
        search: '',
        seletedAlphabet: "",
        selectedAlphabetIndex: -1,
        showKeywordDetailScreen: false,
        selectedKeyword: "",
        selectedKeywordIndex: -1,
    }


    componentDidMount() {
        this.getComprehensionKeywords({}, this.filter)
    }

    getComprehensionKeywords(payload, filter, callback) {
        if (!payload) payload = filter || {}

        payload.page = filter.page || 1
        payload.limit = this.limit

        this.currentPage = payload.page

        this.setState({ isLoading: true, comprehensionKeywordList : [] })

        console.log(payload)

        DictionaryApi.getComprehensionKeywords(payload).then(response => {
            this.alphabetHash = response.alphabetHash ? response.alphabetHash : {}
            this.setState({
                comprehensionKeywordList: response.response,
                meta: response.meta || {},
                isLoading: false
            })
        }).catch(err => {
            this.setState({ isLoading: false, meta: {}, comprehensionKeywordList: [] })
            console.log(err)
        })

    }


    onPageSelected = (selectedPage, startIndex) => {
        this.currentPage = selectedPage
        this.onPageSelected(selectedPage, startIndex)
    }

    onPageSelected = (selectedPage, startIndex) => {
        this.startIndex = startIndex
        this.filter.page = selectedPage
        this.setState({ selectedPage })
        this.getComprehensionKeywords(this.filter, this.filter)
    }

    onChangeHandler(event, key) {
        let value = event.target.value
        this.setState({ [key]: value, selectedAlphabetIndex: -1 })
    }

    clearFilter = () => {

        this.setState({
            search: "",
            selectedAlphabetIndex: -1,

        }, () => {

            this.onFilterGo()
        })

    }

    onFilterGo() {
        let payload = {}
        if (this.state.search) {
            payload.search = this.state.search
        }


        this.getComprehensionKeywords(payload, this.filter)

    }

    getAlphabets() {
        let alphabets = []

        for (let i = 65; i <= 90; i++) {

            let character = ""

            if (this.alphabetHash[String.fromCharCode(i)]) {
                character = <div className={`alphabet-wrapper text-center cursor-pointer
             ${this.state.selectedAlphabetIndex === i ? "selected-alphabet-bg" : ""}`}
                    onClick={() => this.setAlphabet(i)}
                >{String.fromCharCode(i)}</div>
            } else {
                character = <div className={`alphabet-wrapper text-center disabled-alphabet
                `}
                >{String.fromCharCode(i)}</div>
            }





            alphabets.push(character)
        }

        return alphabets;
    }

    setAlphabet(index) {
        this.alphabetSearch(String.fromCharCode(index))
        this.setState({ selectedAlphabetIndex: index })
    }

    alphabetSearch(alphabet) {

        let payload = {}
        if (alphabet) {
            payload.alphabetSearch = alphabet
        }

        console.log(payload)

        this.getComprehensionKeywords(payload, this.filter)
    }

    showKeywordDetail(keyword, index) {
        this.setState({ showKeywordDetailScreen: true, selectedKeyword: keyword, selectedKeywordIndex: index })
    }

    hideKeywordDetailScreen() {
        this.setState({ showKeywordDetailScreen: false, selectedKeyword: "", selectedKeywordIndex: -1 })
    }







    renderBreadcrumb = () => {
        return (
            <div className='breadcrumb '>
                <span className="bread-crumb-title" onClick={this.goToChapterListScreen}>{`${this.props.selectedClass || ""} >`}</span>
                <span className='pl-2 bread-crumb-title' onClick={() => this.toggleBack()}>{`${this.props.chapterTitle || ""}`}</span>
                {/* <span className='pl-2'>{this.props.selectedElo?.conceptTitle} {`>`} </span>
                <span className='active pl-2'>{this.props.selectedElo?.title}</span> */}
            </div>
        )
    }


    render() {


        if (this.state.showKeywordDetailScreen) {
            return <KeywordDetail keywordDetail={this.state.selectedKeyword} back={() => this.hideKeywordDetailScreen()} />
        }


        return (
            <div className="dictionary-list">
                {/* <div className='' >
                    <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.toggleBack()} />
                </div> */}
                <div className="">
                    <div className='row align-items-center heading-wrapper mt-2 p-2'>
                        {/* <img className="case-study-bg" src={getImageSource(ImageConstants.ACTIVITY_BG)} /> */}
                        <div className='col-5 d-flex align-items-center'>
                            <div>
                                <img className='orange-play-icon mr-2' src={getImageSource(ImageConstants.DICTIONARY_IMAGE)} />
                            </div>
                            <div>
                                <div className="header-text">{`Dictionary`}</div>
                                {/* <div className=''>{this.renderBreadcrumb()}</div> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-4 mb-4 position-relative" onMouseEnter={ReactTooltip.rebuild}>
                    <img className="search-icon-size cursor-pointer" src={getImageSource(ImageConstants.SEARCH_ICON)}
                        onClick={() => this.onFilterGo()}
                        data-tip={"Search"} />
                    <div className="col-10">
                        <div>
                            <input className="cw-input" value={this.state.search} onChange={(event) => this.onChangeHandler(event, "search")} placeholder='Search Word' />
                        </div>

                    </div>
                    <div className="col-1">
                        <img className="filter-icon cursor-pointer"
                            onClick={() => this.onFilterGo()}
                            data-tip={"Filter"}
                            src={getImageSource(ImageConstants.FILTER_ICON)} />
                    </div>
                    <div className="col-1 clear-button-wrapper">
                        <div className="filter-button  d-inline-block">
                            <button className={`cw-button clear-btn`} onClick={() => this.clearFilter()} >{"CLEAR"}</button>
                        </div>
                    </div>

                </div>
                <div className="text-search">
                    {'Alphabetical Search'}
                </div>
                <div className="d-flex justify-content-between mt-3 mb-4">
                    {
                        this.getAlphabets()
                    }
                </div>
                <div className="comprehension-keyword-list-wrapper mt-3">
                    {
                        this.state.comprehensionKeywordList &&
                            this.state.comprehensionKeywordList.length ?
                            this.state.comprehensionKeywordList.map((keyword, index) => (
                                <div className="keyword-wrapper mb-4 cursor-pointer" onClick={() => this.showKeywordDetail(keyword, index)} >
                                    <div className="keyword-title">{keyword.title}</div>
                                    <div className="keyword-meaning row">
                                        {/* <div className="col-2 max-width-for-meaning">Meaning :</div> */}
                                        <div className="col margin-left-for-content">
                                            <CwContentViewer content={keyword.meaning} />
                                        </div>

                                    </div>
                                </div>
                            ))
                            :
                            <div>No Words</div>
                    }
                </div>
                {
                    <div className='card-footer' style={{ backgroundColor: "transparent" }}>
                        {
                            this.state.meta?.totalPages ?
                                <PaginationComponent startIndex={this.startIndex} selectedPage={this.currentPage} totalPages={this.state.meta?.totalPages} onPageSelected={this.onPageSelected} /> : ''
                        }
                    </div>
                }
                <ReactTooltip ref={el => this.tooltip = el} multiline={true} place='bottom' type='dark' effect='solid' event="mouseover mouseenter" eventOff="mouseleave mouseout scroll mousewheel blur" />
            </div>
        )
    }

}

export default Dictionary;